// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"cde60503","239":"3edeec54","453":"f3e826fb","667":"59ec8168","762":"356d1079","977":"9e685e74"}[chunkId] + ".chunk.js";
};